import {useState} from "react";
import {Body, Desc, Images, Logo, PageIcon, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";
import Verify from "../Campaign/verify";
import {ContainerImage} from "../../components/Container";

export default function ReAuth(props:any) {
    const {campaign, customer, T} = useApp();
    const [step, setStep] = useState("");

    return (
        <ContainerImage style={{minHeight: '100%', height: '100%', display: 'flex', flexDirection: 'column'}}>
            <Logo>
                <LogoIcon/>
            </Logo>
            <Body>
                <Images>
                    <PageIcon/>
                </Images>
                <Title>401 Error</Title>
                <Desc>{T('Authorization required.')}</Desc>
                {/*<Next onClick={() => {setStep('verify')}}>{T("Login again")}</Next>*/}
            </Body>

            {step === 'verify' ? (<Verify onClose={event => {
                setStep("")
            }}/>) : null}
        </ContainerImage>
    );
}